
type Props = {
	email: string
}

export const BillingEmailField = ({ email }: Props) => {
	return (
		<div className="billing-field">
			<div className="billing-field__title">
				<div className="header">
					<h6>Billing email</h6>
					<p className="description">{email}</p>
				</div>
			</div>
		</div>
	)
}
